<p-toast key="for-help" position="bottom-center" class="help-bar">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <span class="pi-fw far fa-lightbulb" style="color:red;font-size:1.5rem;"></span> {{message.detail}}
      </div>
    </div>
  </ng-template>  
</p-toast>

<p-toast key="for-entity" position="bottom-right"></p-toast>

<p-confirmDialog #cd [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Delete" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div *ngIf="selectedCategoryName !== ''" style="height:100%">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>
      
      <span style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="selectCategory(selectedCategoryName)"></button>

        <!-- Display only on bigger than md screens-->
        <span class="p-d-none p-d-md-inline">
          <button pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add {{selectedCategoryName}}" 
                  icon="pi-fw fas fa-plus-circle"
                  (click)="openEntityForm(null)"></button>
        </span>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button pButton type="button" 
                  class="p-button-rounded"  
                  icon="pi-fw fas fa-plus-circle"
                  (click)="openEntityForm(null)"></button>
        </span>
      </span>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon" pBadge 
         severity="info"
         pTooltip="Total Number of {{selectedCategoryName}}: {{entities.length}}"
         value="{{entities.length}}"></i>
    </div>
  </p-toolbar>

  <div style="height: calc(100% - 36px)">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false">

      <p style="color:white" >Loading data... </p>
    </ngx-spinner>

    <ag-grid-angular
        *ngIf="entities.length > 0"
        style="width: 100%; height:100%;"
        class="ag-theme-alpine"
        rowSelection="single"
        [gridOptions]="gridOptions"
        [context]="context"
        [rowData]="entities"
        [columnDefs]="gridHeaders"
        [enterMovesDown]="true"
        [enterMovesDownAfterEdit]="true"
        (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
<!-- 
  <div class="card-header bg-info text-white p-1">
    <div class="float-right mt-1 pl-2">
      Total {{selectedCategoryName}}: 
      <span *ngIf="entities.length > 0" class="badge badge-pill badge-warning">
        {{entities.length}}
      </span>
    </div>

    <a (click)="openEntityForm(null)"
       class="btn btn-info btn-sm mr-2">
       <i class="fas fa-plus-circle fa-lg mr-1"></i>Add {{selectedCategoryName}}
    </a>
    <a (click)="selectCategory(selectedCategoryName)"
       class="btn btn-info btn-sm mr-2">
      <i class="fas fa-sync-alt fa-lg mr-1" [class.fa-spin]="entityLoading"></i> Refresh
    </a>
  </div>
  <div class="card-body m-1 p-0 h-100">
    <ag-grid-angular
      *ngIf="entities.length > 0"
      style="width: 100%; height:100%;"
      class="ag-theme-alpine"
      rowSelection="single"
      [gridOptions]="gridOptions"
      [context]="context"
      [rowData]="entities"
      [columnDefs]="gridHeaders"
      [enterMovesDown]="true"
      [enterMovesDownAfterEdit]="true"
      (gridReady)="onGridReady($event)"
      >
    </ag-grid-angular>
  </div> -->
</div>